import CreateHeaderActionButton from './components/CreateHeaderActionButton'
import HeaderActionGroup from './components/HeaderActionGroup'
import CSVButton from '../../../CSVButton'
import { useCIMSTableContext } from '../../CIMSTableContext'
import DeepLinkHeaderActionButton from './components/DeepLinkHeaderActionButton'
import CollapseHeaderActionButton from './components/CollapseHeaderActionButton'
import ReloadHeaderActionButton from './components/ReloadHeaderActionButton'
import PayItemsHeaderSelect from './components/PayItemsHeaderSelect'
import { DisabledActionButtonOptions } from '../../types'
import CustomHeaderActionButtons from './components/CustomHeaderActionButtons'
import { PopconfirmProps } from 'antd'

export function HeaderActionButtons<T extends object>() {
  const { actions, disable } = useCIMSTableContext<T>()
  const { create, csv, custom, deepLink, onReload, payItems, collapse } =
    actions.header
  const hasLeftCustomActions = custom?.some(
    ({ placement }) => !placement || placement === 'left'
  )
  const hasRightCustomActions = custom?.some(
    ({ placement }) => placement === 'right'
  )

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '0.5rem 1.5rem',
      }}
    >
      <HeaderActionGroup>
        {csv && <CSVButton entity={csv} />}
        {create && <CreateHeaderActionButton />}
        {hasLeftCustomActions && <CustomHeaderActionButtons />}
        {payItems && !payItems.hidden && <PayItemsHeaderSelect />}
      </HeaderActionGroup>
      <HeaderActionGroup>
        {deepLink.value && !disable?.showAll && <DeepLinkHeaderActionButton />}
        {collapse.visible && <CollapseHeaderActionButton />}
        {hasRightCustomActions && (
          <CustomHeaderActionButtons placement="right" />
        )}
        {onReload && <ReloadHeaderActionButton />}
      </HeaderActionGroup>
    </div>
  )
}

export type HeaderActionButtonFn<T, U> = (records: T[]) => U

export interface HeaderActionButtonOptions<T> {
  /**
   * whether this button should be disabled
   *
   * @default false
   */
  disabled?:
    | false
    | DisabledActionButtonOptions
    | HeaderActionButtonFn<T, false | DisabledActionButtonOptions>
  confirm?: PopconfirmProps
  /**
   * whether the button should be loading or not
   */
  loading?: boolean
}
